module.exports = __webpack_public_path__ + "img/gold-c.1f7a08df.png";